const DELIVERY_GUIDE_STATUS_OPTIONS = [
  { value: 'draft', label: 'Borrador', tone: 'bg-gray-100 text-gray-700 border-gray-200' },
  { value: 'pending_loading', label: 'Pendiente de carga', tone: 'bg-amber-100 text-amber-700 border-amber-200' },
  { value: 'received', label: 'Recepción conforme', tone: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  { value: 'received_with_differences', label: 'Recibido con diferencias', tone: 'bg-orange-100 text-orange-700 border-orange-200' },
  { value: 'completed', label: 'Completado', tone: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  { value: 'pending', label: 'Pendiente', tone: 'bg-amber-100 text-amber-700 border-amber-200' },
  { value: 'in_transit', label: 'En ruta', tone: 'bg-blue-100 text-blue-700 border-blue-200' },
  { value: 'delivered', label: 'Entregada', tone: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  { value: 'cancelled', label: 'Cancelada', tone: 'bg-red-100 text-red-700 border-red-200' },
  { value: 'rejected', label: 'Rechazada', tone: 'bg-rose-100 text-rose-700 border-rose-200' },
];

const DELIVERY_GUIDE_STATUS_LABELS = DELIVERY_GUIDE_STATUS_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

const DELIVERY_GUIDE_STATUS_TONES = DELIVERY_GUIDE_STATUS_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.tone;
  return acc;
}, {});

const normalizeGuideStatus = (status) => {
  if (!status) return '';
  return String(status).trim().toLowerCase();
};

const getDeliveryGuideStatusLabel = (status) => {
  const normalized = normalizeGuideStatus(status);
  if (!normalized) return 'Sin estado';
  return DELIVERY_GUIDE_STATUS_LABELS[normalized] || status;
};

const getDeliveryGuideStatusTone = (status) => {
  const normalized = normalizeGuideStatus(status);
  return (
    DELIVERY_GUIDE_STATUS_TONES[normalized]
    || 'bg-gray-100 text-gray-600 border-gray-200'
  );
};

export {
  DELIVERY_GUIDE_STATUS_OPTIONS,
  getDeliveryGuideStatusLabel,
  getDeliveryGuideStatusTone,
  normalizeGuideStatus,
};
